module.exports = __webpack_public_path__ + "e50f6985b9aebb7c0c273959fba54c86.pdf";